<template>
  <div>
    <b-navbar type="dark" variant="dark" fixed="top">
      <b-navbar-brand :to="{ name: 'home' }">
        poi-hub.com
      </b-navbar-brand>
      <b-navbar-nav class="navbar-nav" data-cy="navFooterRight">
        <b-nav-item v-if="isAdmin" :to="{ name: 'pois-map' }">
          POIs (map)
        </b-nav-item>
        <b-nav-item :to="{ name: 'pois-list' }">
          POIs
        </b-nav-item>
        <b-nav-item v-if="isContributor" :to="{ name: 'poi-add' }">
          <font-awesome-icon :icon="['fas', 'cloud-upload-alt']" /> Add POI
        </b-nav-item>
        <b-nav-item v-if="isValidator" :to="{ name: 'pois-validate' }">
          Validate
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="navbar-nav ml-auto" data-cy="navFooterRight">
        <b-nav-item v-if="!user.loggedIn" :to="{ name: 'login' }" class="pl-1 pr-1 pl-sm-2 pr-sm-2">
          Login
        </b-nav-item>
        <b-nav-item-dropdown v-if="user.loggedIn" right>
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <em v-if="user.data.displayName">{{ user.data.displayName }}</em>
            <em v-else-if="userProfileAlias.length">{{ userProfileAlias }}</em>
            <em v-else>{{ user.data.email }}</em>
            <b-avatar v-if="false" class="ml-1" size="sm"></b-avatar>
          </template>
          <b-dropdown-item :to="{ name: 'profile' }">Profile</b-dropdown-item>
          <b-dropdown-item v-if="isValidator" :to="{ name: 'pois-validate' }">Validate</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'logout' }">Logout</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    <div class="nav-placeholder-header"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'nav-header',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'auth/isAdmin',
      isContributor: 'auth/isContributor',
      isValidator: 'auth/isValidator',
      userProfileAlias: 'auth/userProfileAlias',
    }),
  },
};
</script>

<style scoped>
.nav-placeholder-header {
  height: 56px;
}
</style>
